import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { SettingsState } from '@/store/settings/types'

const getters: GetterTree<SettingsState, RootState> = {
    preference({ preferences }): (type: string, key: string) => any {
        return (type: string, key: string) => preferences[type][key]
    }
}

export default getters
